import { HiX } from 'react-icons/hi';
import { useSelector } from 'react-redux';

import Overlay from '@core/blocks/edu-match/components/Overlay';
import { selectDcsDegrees } from '@core/reducers/dcsSlice';
import cn from '@core/utils/classNames';

import styles from './SlideUpPopup.module.css';
import { TPopup } from './types';

const SlideUpPopup: TPopup = ({ show, onClose, children, closeOnOverlayClick = false }) => {
  const overlayClickHandler = closeOnOverlayClick ? onClose : undefined;
  const dcsDegrees = useSelector(selectDcsDegrees);

  // Want the popup size to be smaller for undergrad DCSs
  const isUndergrad = dcsDegrees.includes("Associate's") || dcsDegrees.includes("Bachelor's");

  if (!show) return null;

  return (
    <div className={styles.popupContainer}>
      <Overlay clickHandler={overlayClickHandler} />
      <div className={cn(styles.popup, isUndergrad && styles.revampPopup)}>
        {onClose && (
          <button data-testid="popup-close-btn" type="button" className={styles.closeBtn} onClick={onClose}>
            <HiX size="1.5rem" />
          </button>
        )}
        {children}
      </div>
    </div>
  );
};

export default SlideUpPopup;
